import {GridFooter} from 'modules/ProductsGrid/components/GridFooter/GridFooter';
import {GridGroup} from 'modules/ProductsGrid/components/GridGroup/GridGroup';
import {GridHeader} from 'modules/ProductsGrid/components/GridHeader/GridHeader';
import {ProductsGridGroupState} from 'modules/ProductsGrid/containers/ProductsGridContainer/reducer';
import {
    ProductGridItemData,
    ProductsGridTotals,
} from 'modules/ProductsGrid/lib/types';
import {FC} from 'react';

import styles from './Grid.module.css';

type Props = {
    products: Record<number, ProductGridItemData>;
    groupsIds: number[];
    groups: Record<number, ProductsGridGroupState>;
    makeHandleRemove: ({
        productId,
        groupId,
    }: {
        productId: number;
        groupId: number;
    }) => () => void;
    makeHandleRestore: ({
        productId,
        groupId,
    }: {
        productId: number;
        groupId: number;
    }) => () => void;
    makeHandleChangeCount: (id: number) => (count: number) => void;
    makeHandlePreviewClick: (id: number) => () => void;
    previewIsClickable: boolean;
    totals: ProductsGridTotals;
};
export const Grid: FC<Props> = ({
    products,
    groupsIds,
    groups,
    makeHandleRemove,
    makeHandleRestore,
    makeHandleChangeCount,
    makeHandlePreviewClick,
    previewIsClickable,
    totals,
}) => {
    return (
        <div className={styles.block}>
            <GridHeader />

            {groupsIds.map((groupId) => {
                const group = groups[groupId];
                if (!group) {
                    return null;
                }

                const groupTotal = totals.groups[groupId];

                return (
                    <GridGroup
                        key={group.name}
                        group={group}
                        groupTotal={groupTotal}
                        products={products}
                        previewIsClickable={previewIsClickable}
                        makeHandleRemove={makeHandleRemove}
                        makeHandleRestore={makeHandleRestore}
                        makeHandleChangeCount={makeHandleChangeCount}
                        makeHandlePreviewClick={makeHandlePreviewClick}
                    />
                );
            })}

            <GridFooter totals={totals} />
        </div>
    );
};
